export const SCALING_MODES = {
    fit: "fit",
    enhance: "enhance"
};

export function normalizeScalingMode(mode) {
    return mode === SCALING_MODES.fit ? SCALING_MODES.fit : SCALING_MODES.enhance;
}

export function computeMaxFitResolution(sourceWidth, sourceHeight, tilesWide, tilesHigh) {
    if (!Number.isFinite(sourceWidth) || !Number.isFinite(sourceHeight)) {
        return null;
    }

    if (!Number.isFinite(tilesWide) || !Number.isFinite(tilesHigh) || tilesWide <= 0 || tilesHigh <= 0) {
        return null;
    }

    const widthLimited = Math.floor(sourceWidth / tilesWide);
    const heightLimited = Math.floor(sourceHeight / tilesHigh);
    const maxFit = Math.min(widthLimited, heightLimited);

    if (!Number.isFinite(maxFit) || maxFit < 1) {
        return 0;
    }

    return maxFit;
}

export function resolveEffectiveResolution(selectedResolution, maxFitResolution, scalingMode) {
    if (!Number.isFinite(selectedResolution) || selectedResolution < 1) {
        return 0;
    }

    if (normalizeScalingMode(scalingMode) !== SCALING_MODES.fit) {
        return selectedResolution;
    }

    if (!Number.isFinite(maxFitResolution) || maxFitResolution < 1) {
        return selectedResolution;
    }

    return Math.min(selectedResolution, maxFitResolution);
}
